import React from "react"

import { productCardVariationName } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

type Props = {
  product: Pick<ProductCardDataType, "variationName">
}

export const ProductCardVariationName: React.FC<Props> = ({ product }) => {
  if (!product.variationName) return null
  return <p className={productCardVariationName}>{product.variationName}</p>
}
